import { parseRecordList, readApiData } from "@/v2/api/response";
import type { ApiResponse } from "@/v2/api/response";
import type { FeedMappingRecord } from "../types";

export type FeedMappingsListClient = (
  entityId: string | number,
  filters?: Record<string, unknown>,
) => Promise<ApiResponse>;

export type FeedConfigMappingsClient = {
  getFeedTypeMappings: FeedMappingsListClient;
  getFeedInstanceMappings: FeedMappingsListClient;
};

function readAfterWriteFilters(options?: { isReadAfterWrite?: boolean }) {
  return { isReadAfterWrite: options?.isReadAfterWrite === true };
}

export async function fetchFeedTypeMappingsList(
  client: FeedMappingsListClient,
  entityId: string | number,
  options?: { isReadAfterWrite?: boolean },
): Promise<FeedMappingRecord[]> {
  const raw = readApiData(await client(entityId, readAfterWriteFilters(options)));
  return parseRecordList(raw);
}

export async function fetchFeedInstanceMappingsList(
  client: FeedMappingsListClient,
  entityId: string | number,
  options?: { isReadAfterWrite?: boolean },
): Promise<FeedMappingRecord[]> {
  const raw = readApiData(await client(entityId, readAfterWriteFilters(options)));
  return parseRecordList(raw);
}

export type FeedConfigMappingsData = {
  feedTypeMappings: FeedMappingRecord[];
  feedInstanceMappings: FeedMappingRecord[];
};

export async function loadFeedConfigMappings(
  client: FeedConfigMappingsClient,
  entityId: string | number,
  options?: { isReadAfterWrite?: boolean },
): Promise<FeedConfigMappingsData> {
  const [feedTypeMappings, feedInstanceMappings] = await Promise.all([
    fetchFeedTypeMappingsList(client.getFeedTypeMappings, entityId, options),
    fetchFeedInstanceMappingsList(client.getFeedInstanceMappings, entityId, options),
  ]);

  return { feedTypeMappings, feedInstanceMappings };
}
